var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.117188 8C0.117188 3.58172 3.69891 0 8.11719 0H32.1172C36.5355 0 40.1172 3.58172 40.1172 8V32C40.1172 36.4183 36.5355 40 32.1172 40H8.11719C3.69891 40 0.117188 36.4183 0.117188 32V8Z",
    fill: "#F3F2F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 25V27C12.1172 27.5304 12.3279 28.0391 12.703 28.4142C13.078 28.7893 13.5868 29 14.1172 29H26.1172C26.6476 29 27.1563 28.7893 27.5314 28.4142C27.9065 28.0391 28.1172 27.5304 28.1172 27V25M15.1172 17L20.1172 12M20.1172 12L25.1172 17M20.1172 12V24",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/Upload icon.5ffbd87b2d1e3a4fed5035f04121da5b.svg";
export { ForwardRef as ReactComponent };